import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/navbar.css";
import axios from "axios";
import translations from "../resources/translations";
import { IoMdMenu, IoMdClose, IoMdArrowBack, IoMdArrowForward } from "react-icons/io";

export default function Navbar({ setLanguage }) {
  const path = useLocation().pathname;
  const [marqueeData, setMarqueeData] = useState([]);
  const currentLanguage = translations[setLanguage] || translations["mr"];
  const url = process.env.REACT_APP_BASE_URL;
  
  // Mobile navigation state
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileMenuLevel, setMobileMenuLevel] = useState(0);
  const [mobileMenuStack, setMobileMenuStack] = useState([]);
  
  // Desktop dropdown states
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  
  // Navigation data structure
  const navigationData = [
    {
      id: 'home',
      label: currentLanguage.navbarItem?.home || 'Home',
      path: '/',
      type: 'link'
    },
    {
      id: 'daji-maharaj',
      label: currentLanguage.navbarItem?.["Daji Maharaj"] || 'Daji Maharaj',
      path: '/dajimah',
      type: 'link'
    },
    {
      id: 'about-sansthan',
      label: currentLanguage.navbarItem?.["About Sansthan"] || 'About Sansthan',
      type: 'dropdown',
      children: [
        {
          id: 'history',
          label: currentLanguage.navbarItem?.History || 'History',
          path: '/sansthan',
          type: 'link'
        },
        {
          id: 'upkram',
          label: currentLanguage.navbarItem?.Upkram || 'Upkram',
          type: 'dropdown',
          children: [
            {
              id: 'varshik-utsav',
              label: currentLanguage.navbarItem?.["Varshik Utsav"] || 'Varshik Utsav',
              path: '/varshik-utsav',
              type: 'link'
            },
            {
              id: 'janmotsav',
              label: currentLanguage.navbarItem?.Janmotsav || 'Janmotsav',
              path: '/janmotsav',
              type: 'link'
            },
            {
              id: 'chaturmas',
              label: currentLanguage.navbarItem?.["Chaturmas(Dwadashi Vrat)"] || 'Chaturmas',
              path: '/chaturmas',
              type: 'link'
            },
            {
              id: 'mahashivratra',
              label: currentLanguage.navbarItem?.["Mahashivratra Padyatra"] || 'Mahashivratra Padyatra',
              path: '/mahashivratra',
              type: 'link'
            },
            {
              id: 'nityopasna',
              label: currentLanguage.navbarItem?.Nityopasna || 'Nityopasna',
              path: '/nityopasna',
              type: 'link'
            }
          ]
        },
        {
          id: 'parampra',
          label: currentLanguage.navbarItem?.Parampra || 'Parampra',
          path: '/parampra',
          type: 'link'
        },
        {
          id: 'vividh-pooja',
          label: currentLanguage.navbarItem?.["Vividh Pooja"] || 'Vividh Pooja',
          path: '/vividhPooja',
          type: 'link'
        }
      ]
    },
    {
      id: 'gangaji',
      label: currentLanguage.navbarItem?.["Gangajibapu Maharaj"] || 'Gangajibapu Maharaj',
      path: '/gangaji',
      type: 'link'
    },
    {
      id: 'vedpathshala',
      label: currentLanguage.navbarItem?.Vedpathshala || 'Vedpathshala',
      type: 'dropdown',
      children: [
        {
          id: 'about-vedpathshala',
          label: currentLanguage.navbarItem?.["About Vedpathshala"] || 'About Vedpathshala',
          path: '/about-vedpathshala',
          type: 'link'
        },
        {
          id: 'admission',
          label: currentLanguage.navbarItem?.["Admission Process"] || 'Admission Process',
          path: '/admission',
          type: 'link'
        },
        {
          id: 'education',
          label: currentLanguage.navbarItem?.["Education Details"] || 'Education Details',
          path: '/education',
          type: 'link'
        }
      ]
    },
    {
      id: 'goshala',
      label: currentLanguage.navbarItem?.Goshala || 'Goshala',
      type: 'dropdown',
      children: [
        {
          id: 'about-goshala',
          label: currentLanguage.navbarItem?.["About Goshala"] || 'About Goshala',
          path: '/about-goshala',
          type: 'link'
        },
        {
          id: 'why-goseva',
          label: currentLanguage.navbarItem?.["Why Goseva"] || 'Why Goseva',
          path: '/why-goseva',
          type: 'link'
        }
      ]
    },
    {
      id: 'seva-mandal',
      label: currentLanguage.navbarItem?.["Seva Mandal"] || 'Seva Mandal',
      path: '/sevaMandal',
      type: 'link'
    },
    {
      id: 'publication',
      label: currentLanguage.navbarItem?.Publication || 'Publication',
      path: '/publication',
      type: 'link'
    },
    {
      id: 'blogs',
      label: currentLanguage.navbarItem?.Blogs || 'Blogs',
      type: 'dropdown',
      children: [
        {
          id: 'all-blogs',
          label: currentLanguage.navbarItem?.["All Blogs"] || 'All Blogs',
          path: '/blogs',
          type: 'link'
        },
        {
          id: 'donate-now',
          label: currentLanguage.navbarItem?.["Donate Now"] || 'Donate Now',
          path: '/donation-details',
          type: 'link'
        }
      ]
    },
    {
      id: 'gallery',
      label: currentLanguage.navbarItem?.Gallery || 'Gallery',
      type: 'dropdown',
      children: [
        {
          id: 'all-gallery',
          label: currentLanguage.navbarItem?.["All Gallery"] || 'All Gallery',
          path: '/gallery',
          type: 'link'
        },
        {
          id: 'all-videos',
          label: currentLanguage.navbarItem?.["All Videos"] || 'All Videos',
          path: '/video-gal',
          type: 'link'
        }
      ]
    },
    {
      id: 'contact',
      label: currentLanguage.navbarItem?.contact || 'Contact',
      path: '/contact',
      type: 'link'
    }
  ];

  useEffect(() => {
    // Fetch events from the backend
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${url}/api/events/get`);
        setMarqueeData(response.data.events);
      } catch (error) {
        console.error("Error fetching marquee data:", error);
      }
    };

    fetchEvents();
    
    // Sticky Navbar logic
    window.scrollTo({ top: 0, behavior: "smooth" });
    const navbar = document.querySelector(".navbar");
    const toggleStickyNavbar = () => {
      if (window.scrollY > 0) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    };

    window.addEventListener("scroll", toggleStickyNavbar);
    
    // Cleanup scroll event listener on unmount
    return () => {
      window.removeEventListener("scroll", toggleStickyNavbar);
    };
  }, []);

  // Handle mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      setMobileMenuLevel(0);
      setMobileMenuStack([]);
    }
  };

  // Handle mobile menu navigation
  const navigateToSubmenu = (item) => {
    if (item.children) {
      setMobileMenuStack([...mobileMenuStack, item]);
      setMobileMenuLevel(mobileMenuLevel + 1);
    }
  };

  // Handle mobile menu back navigation
  const navigateBack = () => {
    if (mobileMenuLevel > 0) {
      setMobileMenuStack(mobileMenuStack.slice(0, -1));
      setMobileMenuLevel(mobileMenuLevel - 1);
    }
  };

  // Get current mobile menu items
  const getCurrentMobileMenuItems = () => {
    if (mobileMenuLevel === 0) {
      return navigationData;
    } else {
      return mobileMenuStack[mobileMenuStack.length - 1]?.children || [];
    }
  };

  // Handle desktop dropdown hover
  const handleDropdownHover = (itemId) => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    setActiveDropdown(itemId);
  };

  // Handle desktop dropdown leave
  const handleDropdownLeave = () => {
    const timeout = setTimeout(() => {
      setActiveDropdown(null);
    }, 300);
    setHoverTimeout(timeout);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        if (isMobileMenuOpen) {
          setIsMobileMenuOpen(false);
          setMobileMenuLevel(0);
          setMobileMenuStack([]);
        } else if (activeDropdown) {
          setActiveDropdown(null);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMobileMenuOpen, activeDropdown]);

  // Handle body scroll lock when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  // Render desktop navigation item
  const renderDesktopNavItem = (item, level = 0) => {
    const isActive = path === item.path;
    const hasChildren = item.children && item.children.length > 0;
    const isDropdownOpen = activeDropdown === item.id;

    if (item.type === 'link') {
      return (
        <Link
          key={item.id}
          to={item.path}
          className={`${level === 0 ? 'nav-item nav-link' : 'dropdown-item'} ${isActive ? 'active' : ''}`}
        >
          {item.label}
        </Link>
      );
    }

    if (hasChildren) {
      return (
        <div
          key={item.id}
          className={`${level === 0 ? 'nav-item dropdown' : 'dropdown-item dropdown'}`}
          onMouseEnter={() => handleDropdownHover(item.id)}
          onMouseLeave={handleDropdownLeave}
        >
          {level === 0 ? (
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              aria-expanded={isDropdownOpen}
              aria-haspopup="true"
            >
              {item.label}
            </Link>
          ) : (
            <button type="button" className="dropdown-item dropdown-toggle" aria-expanded={isDropdownOpen}>
              {item.label}
            </button>
          )}
          <div
            className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}
            role="menu"
          >
            {item.children.map((child) => renderDesktopNavItem(child, level + 1))}
          </div>
        </div>
      );
    }

    return null;
  };

  // Render mobile navigation item
  const renderMobileNavItem = (item) => {
    const isActive = path === item.path;
    const hasChildren = item.children && item.children.length > 0;

    if (item.type === 'link') {
      return (
        <Link
          key={item.id}
          to={item.path}
          className={`mobile-nav-item ${isActive ? "active" : ""}`}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          {item.label}
        </Link>
      );
    }

    if (hasChildren) {
      return (
        <button
          key={item.id}
          className="mobile-nav-item mobile-nav-dropdown"
          onClick={() => navigateToSubmenu(item)}
          aria-expanded="false"
        >
          <span>{item.label}</span>
          <IoMdArrowForward className="mobile-nav-arrow" />
        </button>
      );
    }

    return null;
  };

  return (
    <>
      {/* Top Bar Start */}
      <div className="marquee-container">
        <div className="marquee">
          {marqueeData.map((event, index) => (
            <span key={index} className="marquee-item">
              {`${event.eventName} `}
              &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
      {/* Top Bar End */}

      {/* Nav Bar Start */}
      <div className="navbar navbar-expand-lg">
        <div className="container-fluid">
          {/* Mobile Menu Toggle */}
          <button
            type="button"
            className="navbar-toggler mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className="navbar-toggler-icon">
              {isMobileMenuOpen ? <IoMdClose /> : <IoMdMenu />}
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="desktop-navigation">
            <nav className="navbar-nav" role="navigation" aria-label="Main navigation">
              {navigationData.map((item) => renderDesktopNavItem(item))}
            </nav>
          </div>
        </div>

        {/* Mobile Navigation Overlay */}
        {isMobileMenuOpen && (
          <div className={`mobile-nav-overlay ${isMobileMenuOpen ? "open" : ""}`} onClick={toggleMobileMenu}></div>
        )}

        {/* Mobile Navigation Menu */}
        <div className={`mobile-navigation ${isMobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-nav-content">
            {/* Mobile Menu Header */}
            <div className="mobile-nav-header">
              {mobileMenuLevel > 0 && (
                <button
                  className="mobile-nav-back"
                  onClick={navigateBack}
                  aria-label="Go back"
                >
                  <IoMdArrowBack />
                  <span>Back</span>
                </button>
              )}
              <h3 className="mobile-nav-title">
                {mobileMenuLevel === 0 
                  ? "Menu" 
                  : mobileMenuStack[mobileMenuStack.length - 1]?.label || "Menu"
                }
              </h3>
              <button
                className="mobile-nav-close"
                onClick={toggleMobileMenu}
                aria-label="Close menu"
              >
                <IoMdClose />
              </button>
            </div>

            {/* Mobile Menu Items */}
            <div className="mobile-nav-items">
              {getCurrentMobileMenuItems().map((item) => renderMobileNavItem(item))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
